import './qr-code-panel.less';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { SimpleTitle } from '@meitu/saas-ui/es/title';
import { formatColor } from '@meitu/saas-colors';
import { IQrCodeLayerProps } from '@meitu/saas-editor-core/es/version-types';
import { BaseToolbar } from '@meitu/saas-editor-ui/es/components/base-toolbar';
import { DividerLine } from '@meitu/saas-editor-ui/es/components/divider-line';
import { HeaderToolbar } from '@meitu/saas-editor-ui/es/components/header-toolbar';
import { usePanelLayerId } from '@/hooks/use-panel-layer-id';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';
import { FillFeature } from './components/fill';
import { InfoFeature } from './components/info';
import { OpacityFeature } from './components/opacity';
import { StrokeFeature } from './components/stroke';
import { StyleFeature } from './components/style';

const QrcodeTitle: React.FC<{
    title: string;
    paddingTop?: number;
    border?: boolean;
    fontSize?: number;
}> = React.memo(({ title, border = false, paddingTop = 0, fontSize }) => {
    return (
        <div
            className={classnames('c-qrcode-panel__title', {
                'c-qrcode-panel__title-border': border,
            })}
            style={{ paddingTop }}
        >
            <SimpleTitle text={title} fontSize={fontSize} />
        </div>
    );
});

const QrCodePanel = () => {
    const { $t } = useLocaleStore();

    const layerId = usePanelLayerId() || '';

    const [layer, setLayer] = useState(editor.stage.getLayer(layerId));

    useEffect(() => {
        const handle = editor.stage.onLayerChange(() => {
            setLayer(editor.stage.getLayer(layerId));
        }, layerId);

        setLayer(editor.stage.getLayer(layerId));

        return () => {
            editor.off(handle);
        };
    }, [layerId]);

    const { opacity } = layer;
    const { fill, stroke, strokeGradient, text, official } = layer.data as IQrCodeLayerProps;
    const strokeValue = strokeGradient ? (formatColor(strokeGradient) as string) : stroke;

    if (!layerId) return null;

    return (
        <div className="c-qrcode-panel">
            <HeaderToolbar id={layerId} editor={editor} style={{ padding: 16 }} />

            <InfoFeature id={layerId} text={text} official={official} />
            <DividerLine />
            <QrcodeTitle title={$t((v) => v.panel.qrCodePanel.style)} fontSize={14} />
            <StyleFeature id={layerId} stroke={strokeValue} fill={fill} />
            <QrcodeTitle title={$t((v) => v.panel.qrCodePanel.color)} fontSize={14} />
            {/* 二维码颜色 */}
            <StrokeFeature id={layerId} stroke={strokeValue} />
            {/* 背景色 */}
            <FillFeature id={layerId} fill={fill} />
            {/* 透明度 */}
            <OpacityFeature id={layerId} opacity={opacity} />

            <DividerLine />

            {/* 通用功能 */}
            <BaseToolbar id={layerId} editor={editor} style={{ padding: '0 16px 16px' }} />
        </div>
    );
};

export default React.memo(QrCodePanel);
